/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'transactions': {
    width: 20,
    height: 20,
    viewBox: '0 0 20 20',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M0 0h20v20H0z"/><path pid="1" d="M11.173 18h0H5a2 2 0 01-2-2V4a2 2 0 012-2h10a2 2 0 012 2v7.667h0" _stroke="currentColor" stroke-width="1.2" stroke-linecap="round"/><circle pid="2" _stroke="currentColor" stroke-width="1.2" stroke-linecap="round" cx="16" cy="16" r="2"/><path pid="3" _stroke="currentColor" stroke-linecap="round" d="M5.955 6.279h7.158M5.955 10.279h3.158"/></g>'
  }
})
